import { TwoButtonModalV2 } from '@schenck/rotec-components';

export const DELETE_TENANT_MODAL: TwoButtonModalV2 = {
  title: '',
  text: 'Do you really want to delete the tenant TENANT_NAME?',
  summary: 'Delete Tenant',
  confirmText: 'COMMON_Delete',
  cancelText: 'COMMON_Cancel',
  warning: true,
  darkMode: true,
  width: '732px',
};

export const OVERWRITE_PASSWORDS_MODAL: TwoButtonModalV2 = {
  title: '',
  text: 'Are you sure that you want to overwrite the existing password file? The Data will be lost and cannot be recovered.',
  summary: 'Password File already exists',
  confirmText: 'Overwrite',
  cancelText: 'COMMON_Cancel',
  warning: true,
  darkMode: true,
  width: '732px',
};
